import { ContentType } from 'recharts/types/component/Tooltip';

export const AreaTooltipContent: ContentType<number, string> = ({ active, payload }) => {
  if (active && payload?.length) {
    return (
      <div className='size-fit rounded-lg bg-brand-500 p-2 text-white-100'>
        {payload?.map((item) => {
          const data = item.payload;

          return (
            <small key={`${data.name}-${data.value}`}>
              {data.name} : {data.value.toLocaleString()}
            </small>
          );
        })}
      </div>
    );
  }

  return <></>;
};
